module.exports = __webpack_public_path__ + "img/elecciones20215.ad01308f.jpg";